import { RecentTransactions, SpendingLimitBarUser } from '@components'
import { AccountOverviewList } from '@dashboard'
import { SendIcon } from '@icons'
import { paths, useMyAccountAccessQry, useTransactionsFilterQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'
import { useHistory } from 'react-router-dom'
import './DashboardStaff.scss'

function DashboardStaff() {
  const { hasAnyWritePermission } = useMyAccountAccessQry()

  useTransactionsFilterQry({ accountId: -1 })

  const history = useHistory()

  function handleSendMoneyClick() {
    return history.push(paths.banking.send())
  }

  return (
    <div className='dashboard-staff-wrapper'>
      <div className='dashboard-staff-container'>
        <SpendingLimitBarUser />

        {hasAnyWritePermission && (
          <Button
            type='button'
            color='secondary'
            icon={<SendIcon />}
            text={tr('PORTAL.DASHBOARD.SEND_BUTTON', 'Send')}
            onClick={handleSendMoneyClick}
            data-test='send-money-button'
          />
        )}
      </div>

      <AccountOverviewList />
      <RecentTransactions />
    </div>
  )
}

export default DashboardStaff
